import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { Link } from "react-router";
import Image from "common/components/image";

const QUIZZES = [
  {
    title: "Will your business idea succeed?",
    image: "landing-page/evalutate-startup-idea-quiz-site-hero-optimized.png",
    description:
      "Take our free quiz and get 15 valuable insights to help you grow your business faster.",
    url: "/evaluate-your-startup-idea-quiz/",
    confidential: true,
  },
  {
    title: "How much does the right logo matter?",
    image: "landing-page/logo-quiz-hero-optimized.png",
    description:
      "Answer 5 quick questions & get 15 valuable insights to drive customer loyalty and business growth.",
    url: "/logo-quiz/",
  },
  {
    title: "Reveal your true brand personality!",
    image: "landing-page/brand-archetype-hero.png",
    description:
      "Discover the secret of iconic brands in a 3-minute quiz. Uncover your brand archetype and get 15 insights to elevate your brand.",
    url: "/brand-archetype-quiz/",
  },
];

const ARTICLES = [
  {
    title: "35 Legal Mistakes Every Startup and Growing Business Must Avoid",
    url: "/blog/legal-mistakes/",
    updated: "Nov 5, 2023",
    readingTime: 17,
    image: "35-legal-mistakes.png",
  },
  {
    title: "From LLCs to S Corps, a Detailed Guide to 11 Business Structures",
    url: "/blog/types-of-businesses/",
    updated: "Nov 5, 2023",
    readingTime: 22,
    image: "how-to-start-a-corp.png",
  },
  {
    title:
      "Brand Experience: How to Stand Out and Supercharge Your Business Growth",
    url: "/blog/brand-experience/",
    updated: "Oct 6, 2023",
    readingTime: 15,
    image: "brand-experience.png",
  },
  {
    title: "Brand Strategy: The Ultimate Guide to Building a Powerful Brand",
    url: "/blog/brand-strategy/",
    updated: "Oct 6, 2023",
    readingTime: 26,
    image: "brand-strategy.png",
  },
];

const Resources = ({ background }) => {
  return (
    <section className={cn("block block-resources", background)}>
      <div className="row columns">
        <div className="block-header">
          <h2>Resources to keep you ahead in business</h2>
        </div>
      </div>
      <div className="row">
        <div className="columns small-16 medium-8 quizzes-column">
          <h3>Quiz your way to better decisions</h3>

          {QUIZZES.map((quiz, i) => (
            <div key={i} className="box quiz">
              <h4>{quiz.title}</h4>
              <div className="row align-middle">
                <div className="columns small-16 large-5">
                  <Image src={quiz.image} alt={quiz.title} widths={[150]} />
                </div>
                <div className="columns small-16 large-11">
                  <p>{quiz.description}</p>

                  <Link to={quiz.url}>
                    Start the {quiz.confidential ? "confidential" : "free"} quiz
                    now <i className="fa fa-long-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          ))}

          <Link to="/quizzes/" className="as-h3-important">
            Boost your business IQ: Explore more quizzes!{" "}
            <i className="fa fa-long-arrow-right" />
          </Link>
        </div>
        <div className="columns small-16 medium-8">
          <h3>Actionable insights for business growth</h3>

          {ARTICLES.map((article, i) => (
            <div key={i} className="box article">
              <div className="row align-middle">
                <div className="columns small-16 large-5">
                  <Image
                    src={article.image}
                    alt={article.title}
                    widths={[150]}
                  />
                </div>
                <div className="columns small-16 large-11">
                  <a href={article.url}>{article.title}</a>
                  <div className="meta">
                    updated {article.updated} | {article.readingTime} min read
                  </div>
                </div>
              </div>
            </div>
          ))}

          <a href="/blog/" className="as-h3-important">
            Explore the crowdspring blog{" "}
            <i className="fa fa-long-arrow-right" />
          </a>
        </div>
      </div>
      <div className="row">
        <div className="columns small-16 medium-8 quizzes-column">
          <div className="box promo">
            <div className="row small-gutter align-middle">
              <div className="columns small-gutter small-16 large-5">
                <Image
                  src="smallbiz-resource-center.png"
                  alt="SmallBiz Resource Center"
                  widths={[150]}
                />
              </div>
              <div className="columns small-gutter small-16 large-11">
                <a href="/resources/">SmallBiz Resource Center</a>
                <p>
                  Access expert advice on launching and expanding your business,
                  including naming, design costs, and marketing tips - we've got
                  you covered.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="columns small-16 medium-8">
          <div className="box promo">
            <div className="row small-gutter align-middle">
              <div className="columns small-gutter small-16 large-5">
                <Image
                  src="guides-and-templates-2.png"
                  alt="Expert Guides & Templates"
                  widths={[150]}
                />
              </div>
              <div className="columns small-gutter small-16 large-11">
                <Link to="/guides/">Expert Guides & Templates</Link>
                <p>
                  Unlock business success with our comprehensive guides and
                  templates. Expert advice for every step of your business
                  journey.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Resources.propTypes = {
  background: PropTypes.string,
};

export default Resources;
